import { render, staticRenderFns } from "./BindCustomer.vue?vue&type=template&id=48e9bf46&"
import script from "./BindCustomer.vue?vue&type=script&lang=js&"
export * from "./BindCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports